export const categories = [
  {
    slug: "entertainment",
    name: "娱乐圈瓜",
    short: "娱乐圈",
    icon: "ri-movie-2-line",
    tagline: "片场内外、综艺录制、剧组日常的圈内见闻",
    desc: "从拍摄现场的临时调整到综艺录制的幕后花絮，这里记录娱乐圈那些不那么正式、却常常被反复讨论的瞬间。内容以现场观察与流程科普为主，帮你看懂热闹背后的行业逻辑。",
    count: 1286,
    updated: "今日 18 条",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20vintage%20cinema%20marquee%20and%20abstract%20spotlight%20beams%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20flat%20geometric%20shapes%2C%20no%20people%2C%20magazine%20cover%20art%20style&width=800&height=600&seq=cat-ent-511&orientation=landscape",
  },
  {
    slug: "workplace",
    name: "职场瓜",
    short: "职场",
    icon: "ri-briefcase-4-line",
    tagline: "大厂小厂、入职离职、团队协作的真实切面",
    desc: "把职场里那些说不清道不明的规则摊开来讲：面试话术、绩效沟通、团队磨合、跳槽决策。不站队、不鼓吹，只把不同选择的代价摆清楚，供你判断。",
    count: 943,
    updated: "今日 12 条",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20an%20abstract%20office%20desk%20with%20laptop%20charts%20and%20coffee%20cup%2C%20olive%20green%20and%20cream%20palette%2C%20geometric%20shapes%2C%20no%20people%2C%20minimal%20editorial%20art&width=800&height=600&seq=cat-work-511&orientation=landscape",
  },
  {
    slug: "campus",
    name: "校园瓜",
    short: "校园",
    icon: "ri-graduation-cap-line",
    tagline: "选课社团、宿舍关系、毕业季的青春侧写",
    desc: "校园里的故事总带着一点莽撞和真诚。这里收集选课取舍、社团运营、宿舍相处、升学和实习的过来人经验，写给还在校园里摸索的人。",
    count: 768,
    updated: "今日 9 条",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20open%20books%2C%20clock%20and%20graduation%20cap%20shapes%2C%20golden%20amber%20and%20cream%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=800&height=600&seq=cat-campus-511&orientation=landscape",
  },
  {
    slug: "local",
    name: "同城瓜",
    short: "同城",
    icon: "ri-map-pin-2-line",
    tagline: "街角小店、社区变化、城市生活的小道消息",
    desc: "哪里新开了一家值得排队的店，哪条街最近悄悄变了样，社区里发生了什么。同城板块关注你我每天都在经过的真实生活场景。",
    count: 1042,
    updated: "今日 21 条",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20city%20street%20with%20shop%20facades%20and%20map%20pin%20markers%2C%20coral%20and%20olive%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=800&height=600&seq=cat-local-511&orientation=landscape",
  },
  {
    slug: "industry",
    name: "行业瓜",
    short: "行业",
    icon: "ri-building-4-line",
    tagline: "赛道起落、产品节奏、从业者的一线观察",
    desc: "每个行业都有自己的周期和暗语。行业板块记录赛道变化、岗位需求、产品决策背后的取舍，帮从业者少踩一些重复的坑。",
    count: 612,
    updated: "今日 7 条",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20abstract%20rising%20bar%20charts%20gears%20and%20factory%20silhouettes%2C%20deep%20olive%20and%20cream%20palette%2C%20geometric%20minimal%20editorial%20art%2C%20no%20people&width=800&height=600&seq=cat-ind-511&orientation=landscape",
  },
];